import styled from 'styled-components';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@material-ui/core';
import { ElasticLogo, palette, PrimaryButton, Typography } from '@dev/ee-components';

import { links } from '@/services/dictionaries/links';

const ScreenWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

const LogoWrapper = styled.div`
    padding: 40px 0 40px 19.531vw;
    width: 100%;
    top: 0;
    left: 0;

    @media (max-width: 1024px) {
        padding: 22px 24px;
    }
`;

const Wrapper = styled.div`
    max-width: 570px;
    padding: 0 0 50px;

    @media (max-width: 1024px) {
        padding: 0 24px 50px;
    }
`;

const Title = styled.h1`
    color: ${palette.jacarta[5]};
    font-size: 36px;
    font-family: Nunito;
    font-weight: 600;
    text-align: center;
`;

export const AccountDeleted: FC = (): JSX.Element => {
    const { t } = useTranslation();

    return (
        <ScreenWrapper>
            <LogoWrapper>
                <ElasticLogo color="#32325C" />
            </LogoWrapper>
            <Wrapper>
                <Box mb="25px">
                    <Title>{t('accounthasbeendeleted')}</Title>
                </Box>
                <Box mb="25px">
                    <Typography align="center" variant="body1">
                        {t('accounthasbeendeleted1')}
                    </Typography>
                </Box>
                <Box mb="32px">
                    <Typography align="center" variant="body1">
                        {t('accounthasbeendeleted2')}
                    </Typography>
                </Box>
                <Box display="flex" justifyContent="center">
                    <PrimaryButton size="large" text={t('contact')} href={links.contactPage} />
                </Box>
            </Wrapper>
        </ScreenWrapper>
    );
};
